import { connect } from 'react-redux';

import ErrorCreateModal from './ErrorCreateModal';
import type { RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  config: state.config,
});


export default connect(mapStateToProps)(ErrorCreateModal);
